import { render, staticRenderFns } from "./supplier-transaction-history.vue?vue&type=template&id=133e55aa"
import script from "./supplier-transaction-history.vue?vue&type=script&lang=js"
export * from "./supplier-transaction-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports